export const FETCH_CUSTOMER = 'views/users/FETCH_CUSTOMER'
export const FETCH_VENDER = 'views/users/FETCH_VENDER'

